module.exports = __webpack_public_path__ + "static/media/BlueWheelDrivetshirt&sticker.6bf38d81.webp";